import md5 from 'md5';
import Kostenart from './kostenart';
import Beleg from './beleg';

export default class Ausgabe {
    constructor(
        id, 
        kostenart = '', 
        name = '', 
        datum = '', 
        kosten = 0, 
        bemerkung = '', 
        belege = [],
        lerneinheiten = ''
    ){
        this.id = id || md5(Date.now());
        this.kostenart = kostenart instanceof Kostenart ? kostenart.id : kostenart;
        this.name = name;
        this.datum = datum;
        this.kosten = parseFloat(kosten).toFixed(2);
        this.bemerkung = bemerkung || '';
        this.belege = belege?.map(item => {
            return item instanceof Beleg ? item : new Beleg(item.id, item.abrechnungId, item.filename, item.name, item.beschreibung, item.url, item.type);
        }) || [];
        this.lerneinheiten = lerneinheiten || '';
    }

    toFirestore(){
        return {
            id: this.id || '',
            kostenart: this.kostenart instanceof Kostenart ? this.kostenart.id : this.kostenart || '',
            name: this.name || '',
            datum: this.datum || '',
            kosten: this.kosten ? parseFloat(this.kosten).toFixed(2) : 0,
            bemerkung: this.bemerkung || '',
            belege: this.belege.map(beleg => {
                return beleg.toFirestore();
            }) || [],
            lerneinheiten: this.lerneinheiten || ''
        }
    }
}